/* eslint-disable eqeqeq */
import { extendObservable, makeAutoObservable, set } from "mobx";

const modelInit = {
  scrDefinition: {},
  sections: [],
  id: null,
};

class ScreenStore {
  // api = null;
  //liste = [];

  constructor(props) {
    this.rootStore = props;
    makeAutoObservable(this, {}, { autoBind: true });
    //this.rootStore.api = new Api({ logout: props.mainStore.logout });
    extendObservable(this, modelInit);
  }

  
  *doActivate(params){
    if (this.rootStore.mainStore.tryLogin) {
      return;
    }
    
    this.uidCerere = params.id;
    this.type = params.type;
    //preluare jprop flux
    //var result = yield this.rootStore.mainStore.getFlow(params.type);
    var result = yield this.getScreenDefinitions(params.type);
    if (result && result.noMatch) {
      return;
    }
    set(this.scrDefinition, result);
    this.getData();
  };

  
  getScreenDefinitions = async (type) => {
    this.rootStore.mainStore.isWaiting = true;
    /*
    var results = yield this.rootStore.api.fetch("/api/request/show-new", {
      type: this.type,
      uidCerere: this.uidCerere,
      reload: false,
    });
    */
    var result = {
      screen: {
        SCREEN_ID: 1,
        VERSION: 1,
        UPDATE_DATE: "2024-10-15T10:49:15.853",
        UPDATE_USER: "1",
        SCREEN_CODE: "client.search",
        SCREEN_PATH: "/clienti/search",
        LINK_TITLE: "Cautare client",
        LINK_VISIBLE: 1,
      },
      sections: [
        {
          SECTION_ID: 1,
          SCREEN_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T11:08:06.590",
          UPDATE_USER: "1",
          SCREEN_ZONE: "header",
          SECTION_CODE: "client.search",
          SECTION_TEXT: "sectiunea cu numarul 1",
          SECTION_VISIBLE: 1,
        },
        {
          SECTION_ID: 2,
          SCREEN_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T11:08:06.590",
          UPDATE_USER: "1",
          SCREEN_ZONE: "main",
          SECTION_CODE: "client.search2",
          SECTION_TEXT: "sectiunea nr 2",
          SECTION_VISIBLE: 1,
        },
        {
          SECTION_ID: 3,
          SCREEN_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T11:08:06.590",
          UPDATE_USER: "1",
          SCREEN_ZONE: "main",
          SECTION_CODE: "client.search3",
          SECTION_TEXT: "sectiunea nr 3",
          SECTION_VISIBLE: 1,
        },
        {
          SECTION_ID: 4,
          SCREEN_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T11:08:06.590",
          UPDATE_USER: "1",
          SCREEN_ZONE: "footer",
          SECTION_CODE: "client.search4",
          SECTION_TEXT: "sectiunea nr 4",
          SECTION_VISIBLE: 1,
        },
        {
          SECTION_ID: 5,
          SCREEN_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T11:08:06.590",
          UPDATE_USER: "1",
          SCREEN_ZONE: "main",
          SECTION_CODE: "client.search5",
          SECTION_TEXT: "sectiunea nr 5",
          SECTION_VISIBLE: 1,
        },
        {
          SECTION_ID: 6,
          SCREEN_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T11:08:06.590",
          UPDATE_USER: "1",
          SCREEN_ZONE: "right",
          SECTION_CODE: "client.search6",
          //SECTION_TEXT: "sectiunea nr 6",
          SECTION_VISIBLE: 1,
        },
      ],
      sectionWidgets: [
        { SECTION_ID: 1, WIDGET_ID: 1 },
        { SECTION_ID: 1, WIDGET_ID: 2 },
        { SECTION_ID: 2, WIDGET_ID: 3 },
        { SECTION_ID: 2, WIDGET_ID: 4 },
        { SECTION_ID: 3, WIDGET_ID: 5 },
        { SECTION_ID: 3, WIDGET_ID: 6 },
        { SECTION_ID: 4, WIDGET_ID: 3 },
        { SECTION_ID: 4, WIDGET_ID: 4 },
        { SECTION_ID: 4, WIDGET_ID: 6 },
        { SECTION_ID: 5, WIDGET_ID: 1 },
        { SECTION_ID: 5, WIDGET_ID: 2 },
        { SECTION_ID: 5, WIDGET_ID: 3 },
        { SECTION_ID: 5, WIDGET_ID: 4 },
        { SECTION_ID: 5, WIDGET_ID: 5 },
        { SECTION_ID: 6, WIDGET_ID: 1 },
        { SECTION_ID: 6, WIDGET_ID: 2 },
        { SECTION_ID: 6, WIDGET_ID: 4 },
        { SECTION_ID: 6, WIDGET_ID: 5 },
        { SECTION_ID: 6, WIDGET_ID: 6 },
        { SECTION_ID: 6, WIDGET_ID: 3 },
      ],
      widgets: [
        {
          WIDGET_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T12:18:24.627",
          UPDATE_USER: "1",
          WIDGET_CODE: "client.search.W1",
          TITLE: "Cautare client",
          API: "",
          JPROP:
            '{"save":{"caption":"Cautare"}, "cancel":false, "refresh":false, "size": 6}', // {"xs": 12, "sm": 12, "md":12 }}'
        },
        {
          WIDGET_ID: 2,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T12:18:24.627",
          UPDATE_USER: "1",
          WIDGET_CODE: "client.search.W2",
          TITLE: "Cautare cnp sau x 2",
          API: "",
          JPROP:
            '{"save":{"caption":"Cautare"}, "cancel":false, "refresh":false, "size": 6}', // {"xs": 8, "sm": 8, "md":8 }}'
        },
        {
          WIDGET_ID: 3,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T12:18:24.627",
          UPDATE_USER: "1",
          WIDGET_CODE: "client.search.W3",
          TITLE: "Cautare x 3",
          API: "",
          JPROP:
            '{"save":{"caption":"Cautare"}, "cancel":false, "refresh":false, "size": 6}', //: {"xs": 6, "sm": 5, "md":5 }}'
        },
        {
          WIDGET_ID: 4,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T12:18:24.627",
          UPDATE_USER: "1",
          WIDGET_CODE: "client.search.W4",
          TITLE: "Cautare x 4",
          API: "",
          JPROP:
            '{"save":{"caption":"Cautare"}, "cancel":false, "refresh":false, "size": 6}', //: {"xs":6, "sm": 5, "md":5 }}'
        },
        {
          WIDGET_ID: 5,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T12:18:24.627",
          UPDATE_USER: "1",
          WIDGET_CODE: "client.search.W5",
          TITLE: "client sau x 5",
          API: "",
          JPROP:
            '{"save":{"caption":"Cautare"}, "cancel":false, "refresh":false, "size": 6}', //: {"xs": 3, "sm": 3, "md":3 }}'
        },
        {
          WIDGET_ID: 6,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T12:18:24.627",
          UPDATE_USER: "1",
          WIDGET_CODE: "client.search.W6",
          TITLE: "nume sau x 6",
          API: "",
          JPROP:
            '{"save":{"caption":"Cautare"}, "cancel":false, "refresh":false, "size": 5}', //: {"xs": 4, "sm": 4, "md":4 }}'
        },
      ],
      fields: [
        {
          FIELD_ID: 1,
          WIDGET_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T16:14:36.417",
          UPDATE_USER: "1",
          FIELD_CODE: "search_omni",
          FIELD_TYPE: 1,
          MANDATORY: true,
          IS_READONLY: false,
          IS_VISIBLE: true,
          DISPLAY_ORDER: 1,
          JPROP: '{"caption":"Search box"}',
        },
        {
          FIELD_ID: 2,
          WIDGET_ID: 1,
          VERSION: 1,
          UPDATE_DATE: "2024-10-15T13:29:31.400",
          UPDATE_USER: "1",
          FIELD_CODE: "search_btn",
          FIELD_TYPE: 0,
          MANDATORY: false,
          IS_READONLY: false,
          IS_VISIBLE: true,
          FIELD_ACTION:
            '{"api":{"method":"POST", "url":"/api/desk/client/search", "params":[{"name":"searchString","source":"field",  screen"value":"search_omni",}, {"name":"XVALUE","source":"const",  "value":"stringul de aici",}, {"name":"sucursala","source":"screen",  "value":"sucursala",}, {"name":"nume","source":"field",  "value":"litera",}], "result":[{"search_table":"@json.ds[1]"}]}}',
          DISPLAY_ORDER: 1,
          JPROP: '{"caption":"Cauta"}',
        },
      ],
    };
    this.rootStore.mainStore.isWaiting = false;
    return result;
  };

  
  getData = async (type) => {
    return;
  };
  
  doDeactivate = async () => {
    this.rootStore.mainStore.jprop = null;
    //yield this.clear();
  };
}

export default ScreenStore;
